module.exports = __webpack_public_path__ + "static/media/sem-imagem.31bc2a0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/sem-imagem.jpg
// module id = 891
// module chunks = 0